import { createAction, props } from "@ngrx/store";

export const setCheckoutSetupMobile = createAction("[CHECKOUT] SET_CHECKOUT_SETUP_MOBILE", props<{ setupData: any; valid: boolean }>());
export const setCheckoutSetupMobileContinue = createAction("[CHECKOUT] SET_CHECKOUT_SETUP_MOBILE_CONTINUE", props<{ valid: boolean }>());
